export default __webpack_public_path__ + "static/media/giide-illo-04.c80fc9f7.png";